function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import { Image, IImageProps } from '../Image';
import logoPrimeCompactFillEn from './LogoSber.assets/logoPrimeCompactFillEn.svg';
import logoPrimeCompactFillRu from './LogoSber.assets/logoPrimeCompactFillRu.svg';
import logoPrimeCompactFillWhiteEn from './LogoSber.assets/logoPrimeCompactFillWhiteEn.svg';
import logoPrimeCompactFillWhiteRu from './LogoSber.assets/logoPrimeCompactFillWhiteRu.svg';
import logoPrimeCompactOutlineGreenEn from './LogoSber.assets/logoPrimeCompactOutlineGreenEn.svg';
import logoPrimeCompactOutlineGreenRu from './LogoSber.assets/logoPrimeCompactOutlineGreenRu.svg';
import logoPrimeCompactOutlineWhiteEn from './LogoSber.assets/logoPrimeCompactOutlineWhiteEn.svg';
import logoPrimeCompactOutlineWhiteRu from './LogoSber.assets/logoPrimeCompactOutlineWhiteRu.svg';
import logoPrimeFullEn from './LogoSber.assets/logoPrimeFullEn.svg';
import logoPrimeFullRu from './LogoSber.assets/logoPrimeFullRu.svg';
import logoPrimeFullWhiteEn from './LogoSber.assets/logoPrimeFullWhiteEn.svg';
import logoPrimeFullWhiteRn from './LogoSber.assets/logoPrimeFullWhiteRn.svg';
import logoPrimeMiniGradient from './LogoSber.assets/logoPrimeMiniGradient.svg';
import logoPrimeMiniWhite from './LogoSber.assets/logoPrimeMiniWhite.svg';
const LogoPrimeRuSberKinds = {
  compactFill: logoPrimeCompactFillRu,
  compactFillWhite: logoPrimeCompactFillWhiteRu,
  compactOutlineGreen: logoPrimeCompactOutlineGreenRu,
  compactOutlineWhite: logoPrimeCompactOutlineWhiteRu,
  full: logoPrimeFullRu,
  fullWhite: logoPrimeFullWhiteRn,
  miniGradient: logoPrimeMiniGradient,
  miniWhite: logoPrimeMiniWhite
};
const LogoPrimeEnSberKinds = {
  compactFill: logoPrimeCompactFillEn,
  compactFillWhite: logoPrimeCompactFillWhiteEn,
  compactOutlineGreen: logoPrimeCompactOutlineGreenEn,
  compactOutlineWhite: logoPrimeCompactOutlineWhiteEn,
  full: logoPrimeFullEn,
  fullWhite: logoPrimeFullWhiteEn,
  miniGradient: logoPrimeMiniGradient,
  miniWhite: logoPrimeMiniWhite
};
export const LogoPrime = ({
  alt = 'Логотип Сбер Прайм',
  kind = 'full',
  language = 'ru',
  size = 'auto',
  sizeBy = 'width',
  ...props
}) => {
  const srcProp = language === 'ru' ? LogoPrimeRuSberKinds[kind] : LogoPrimeEnSberKinds[kind];
  if (!srcProp) return null;
  const _size = Number(size);
  return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    alt: alt,
    width: sizeBy === 'width' && _size ? _size : 'auto',
    height: sizeBy === 'height' && _size ? _size : 'auto',
    src: srcProp
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LogoPrime.displayName = 'LogoPrime';
}